module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-11.524a3afb.png";